import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.hanscribe.soap.editor');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-hanscribe-soap-editor',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.hanscribe.soap.editor/view.scss */
:host {
  display: block;
  height: 100%;
}

.hanscribe-component {
  min-height: 1px;
}`],
})
export class PortalHanscribeSoapEditorComponent implements OnInit {
    @Input() context: any;
    public componentId = 'soap.editor';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default PortalHanscribeSoapEditorComponent;